import React from "react";
import { Box, Users, BookOpen, ChartNoAxesColumnIncreasing, Hand, LockKeyhole, EyeOff } from "lucide-react";
import { EditorialIcon } from "./EditorialVisuals";

const PATHS = [
  { title: "Technology", name: "Aky", icon: Box },
  { title: "Capacity", name: "Lead.ai", icon: Users },
  { title: "Research", name: "Research", icon: BookOpen },
];

export const PathDiagram = ({ testId }) => (
  <figure className="path-diagram" data-testid={testId} aria-label="Technology, capacity and research serve AI working inside a box the organisation controls.">
    <div className="path-diagram-branches">
      {PATHS.map(({ title, name, icon }) => (
        <div className="path-diagram-branch" key={title} data-testid={`${testId}-${title.toLowerCase()}`}>
          <EditorialIcon icon={icon} testId={`${testId}-${title.toLowerCase()}-icon`} />
          <span>{title}</span>
          <small>{name}</small>
        </div>
      ))}
    </div>
    <figcaption data-testid={`${testId}-caption`}>AI working inside a box the organisation controls.</figcaption>
  </figure>
);

export const ContainmentDiagram = ({ items, testId }) => {
  const icons = [Hand, LockKeyhole, EyeOff];
  return (
    <figure className="containment-diagram" data-testid={testId}>
      <figcaption className="containment-caption" data-testid={`${testId}-caption`}>
        <span className="mono-label">Your rules</span>
      </figcaption>
      <ul className="cannot" data-testid="aky-cannot-list">
        {items.map((item, index) => (
          <li key={item} className="cannot-item" data-testid={`aky-cannot-item-${index + 1}`}>
            <EditorialIcon icon={icons[index]} testId={`aky-cannot-icon-${index + 1}`} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </figure>
  );
};

const RESEARCH_OUTPUTS = [
  { label: "Aky", detail: "Gates", icon: Box },
  { label: "Lead.ai", detail: "Curriculum", icon: Users },
  { label: "Executives", detail: "Benchmarks", icon: ChartNoAxesColumnIncreasing },
];

export const ResearchFlow = ({ testId }) => (
  <figure className="research-flow" data-testid={testId} aria-label="Research feeds Aky's gates, Lead.ai's curriculum and benchmarks for executives.">
    <div className="research-flow-source" data-testid={`${testId}-source`}>
      <EditorialIcon icon={BookOpen} testId={`${testId}-source-icon`} />
      <span>Research</span>
    </div>
    <div className="research-flow-branches">
      {RESEARCH_OUTPUTS.map(({ label, detail, icon }, index) => (
        <div className="research-flow-item" key={label} data-testid={`${testId}-item-${index + 1}`}>
          <EditorialIcon icon={icon} testId={`${testId}-icon-${index + 1}`} />
          <span>{label}</span>
          <small>{detail}</small>
        </div>
      ))}
    </div>
  </figure>
);